import React from "react";
import StatisticField from "../GreyRectangles/StatisticField";
import GreyCard from "../GreyRectangles/GreyCard";
//import "./Resume.css";
import { SpecificBooking } from "../../../../types/responseTypes";

interface BaseStatisticsCardProps {
  specificBooking: SpecificBooking;
}

const BaseStatisticsCard: React.FC<BaseStatisticsCardProps> = ({
  specificBooking, 
}) => {
  const statistics = {
    totalPower: specificBooking.totalPower, // kW
    totalPowerUnit: "kWh",
    amountSolarPanels: specificBooking.amountSolarPanels, // cantidad de paneles
    solarPanelsPower: specificBooking.solarPanel.power, // W
    solarPanelsPowerUnit: "W",
    inverterQuantity: specificBooking.inverterQuantity, // cantidad de inversores
    inverterPower: specificBooking.inverterPower, // kW
    inverterPowerUnit: "kW",
  };
  
  return (
    <GreyCard>
      {statistics ? (
        <>
          <StatisticField 
            label="Capacidad" 
            power={statistics.totalPower} 
            unit={statistics.totalPowerUnit}
          />
          <StatisticField 
            label="Paneles" 
            quantity={statistics.amountSolarPanels} 
            power={statistics.solarPanelsPower}
            unit={statistics.solarPanelsPowerUnit}
          />
          <StatisticField 
            label="Inversor" 
            quantity={statistics.inverterQuantity} 
            power={statistics.inverterPower} 
            unit={statistics.inverterPowerUnit}
          />
        </>
      ) : (
        <p>Cargando estadísticas...</p>
      )}
    </GreyCard>
  );
};

export default BaseStatisticsCard;
